import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Why from "../components/Why";
import Syllabus from "../components/Syllabus";
import InteractivePreview from "../components/InteractivePreview";
import WhatsIncluded from "../components/WhatsIncluded";
import Testimonials from "../components/Testimonials";
import Packages from "../components/Packages";
import Enroll from "../components/Enroll";
import FAQ from "../components/FAQ";

export default function Course() {
  return (
    <div
      data-testid="course-root"
      className="min-h-screen bg-[#F4F3ED] text-[#0A0A0A] font-body"
    >
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Why />
        <Syllabus />
        <InteractivePreview />
        <WhatsIncluded />
        <Testimonials />
        <Packages />
        <Enroll />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
